import StoredData from './StoredData';

export default StoredData;
